export const male_features = [ //An array of each Male Facial Feature's ID, Atlas, and Name. Optional disable for Hair and/or Beard. There are 22.
  {
    id: '', //ID name.
    atlas: '', //Atlas file.
    name: 'No facial feature' //Show name in textbox.
  },
  {
    id: 'feature11',
    atlas: 'atlas01',
    name: 'Oberon makeup', //Fairy makeup
    layer: "Low" //1 is Lowest, 2 Medium, 3 is Highest.
  },
  {
    id: 'feature6',
    atlas: 'atlas01',
    name: 'Lone Ranger', //Thief mask
    layer: "High"
  },
  {
    id: 'feature7',
    atlas: 'atlas01',
    name: 'Skull makeup', //Skull makeup
    layer: "Low"
  },
  {
    id: 'feature10',
    atlas: 'atlas01',
    name: 'Raider makeup', //Raider black makeup
    layer: "Low"
  },
  {
    id: 'feature1',
    atlas: 'atlas01',
    name: 'Cheek & Forehead scars', //Cheek Forehead scars
    layer: "Low"
  },
  {
    id: 'feature9',
    atlas: 'atlas01',
    name: 'Tyrion scar', //Tyrion scar
    layer: "Low"
  },
  {
    id: 'feature8',
    atlas: 'atlas01',
    name: 'Nick Fury scar', //Nick Fury scar
    layer: "Low"
  },
  {
    id: 'feature5',
    atlas: 'atlas01',
    name: 'Wrinkles', //Wrinkles
    layer: "Low"
  },
  {
    id: 'feature15',
    atlas: 'atlas01',
    name: 'Ghoulish', //Ghoul face
    layer: "Med"
  },
  {
    id: 'feature14',
    atlas: 'atlas01',
    name: 'Nuka-bottle glasses', //Big round glasses
    layer: "High"
  },
  {
    id: 'feature13',
    atlas: 'atlas01',
    name: 'Glasses', //Regular glasses
    layer: "High"
  },
  // {
  //   id: 'feature12',
  //   atlas: 'atlas01',
  //   name: 'Glasses with Van Dyke beard', Regular Glasses with Chin Beard
  //   layer: "High"
  // },
  {
    id: 'feature4',
    atlas: 'atlas01',
    name: 'Road goggles', //Square Goggles
    layer: "High"
  },
  {
    id: 'feature2',
    atlas: 'atlas01',
    name: 'Pince-nez goggles', //Round Goggles
    layer: "High"
  },
  {
    id: 'feature3',
    atlas: 'atlas01',
    name: 'Monocle', //Monocle
    layer: "Med"
  },
  {
    id: 'feature18',
    atlas: 'atlas17',
    name: 'Nose glasses', //Comedian outfit
    layer: "High"
  },
  {
    id: 'feature16',
    atlas: 'atlas01',
    name: 'Clown nose', //Clown nose
    layer: "High"
  },
  {
    id: 'feature21',
    atlas: 'atlas17',
    name: 'Vulcan ears', //Sci-fi fan outfit
    layer: "High"
  },
  {
    id: 'feature19',
    atlas: 'atlas17',
    name: 'Hockey mask', //Horror fan outfit
    disable_beard: 1,
    layer: "High"
  },
  {
    id: 'feature20',
    atlas: 'atlas17',
    name: 'Luchador mask', //Wrestler outfit
    disable_hair: 1,
    layer: "High"
  },
  {
    id: 'feature17',
    atlas: 'atlas17',
    name: 'Ninja mask', //Ninja outfit
    disable_hair: 1,
    disable_beard: 1,
    layer: "High"
  }
]